import React, { useContext } from 'react';
import { Order } from '@hero/schema';
import { TableContext } from '@hero/web-components';
import { StatusBadgeConfigType } from '@hero/web-components';
import { OrderTableColumn, UseOrderAgainConfig, useOrderDrawerStore } from '@hero/hooks-shared';
import { OrderTableCell } from './OrderCell';

export interface OrderRowProps {
  order: Order;
  displayForUser: 'customer' | 'carrier';
  hasDetailDrawer?: boolean;
  statusConfig?: StatusBadgeConfigType;
  columns: OrderTableColumn[];
  updateOrderFn?: (data: { _id: string; pod: { podRef?: string } }) => Promise<Order>;
  orderAgainConfig?: UseOrderAgainConfig;
}

/**
 * Table row component for displaying order information.
 * Opens the OrderDrawer via the store on row click.
 */
export const OrderRow: React.FC<OrderRowProps> = ({
  order,
  displayForUser,
  hasDetailDrawer = true,
  statusConfig,
  columns,
  updateOrderFn,
  orderAgainConfig,
}) => {
  const context = useContext(TableContext);
  const statusBadgeConfig = statusConfig || context?.statusBadgeConfig;
  const openDrawer = useOrderDrawerStore(s => s.open);

  const handleRowClick = () => {
    if (!hasDetailDrawer) return;
    openDrawer(String(order._id));
  };

  return (
    <>
      {columns.map(column => (
        <OrderTableCell
          key={column.key}
          column={column}
          order={order}
          displayForUser={displayForUser}
          statusConfig={statusBadgeConfig}
          hasDetailDrawer={hasDetailDrawer}
          updateOrderFn={updateOrderFn}
          orderAgainConfig={orderAgainConfig}
          onOpenDrawer={handleRowClick}
        />
      ))}
    </>
  );
};
